export default from './EmptyLayout';



// WEBPACK FOOTER //
// ./src/components/Layouts/EmptyLayout/index.js